import apiClient from "../utils/apiClient";

/**
 * BonusesService
 * Client API for bonus calendar state
 * Follows gold standard: service layer encapsulates API calls
 */
class BonusesService {
  /**
   * Get optimized calendar state for a user
   * @param {string} userId
   * @returns {Promise<null|{
   *  hasActiveCalendar:boolean,
   *  readyToStart?:boolean,
   *  canClaimToday?:boolean,
   *  currentDay?:number,
   *  claimedDays?:number[]
   * }>} null when no calendar available
   */
  async getCalendarState(userId) {
    if (!userId) return null;
    const res = await apiClient.get(
      `/api/casino/bonuses/${userId}/calendar-state`,
    );
    const payload = res?.data || null;
    if (!payload) return null;
    // Route returns { success: true, ...state }
    const { success, ...state } = payload;
    if (success) return state;
    return null;
  }
}

const bonusesService = new BonusesService();
export default bonusesService;
